<template>
  <ion-grid class="mt-20" v-if="hasTeamList">
    <div class="player-header"
    v-if="showLineUpHeader && nationalId != 8">
      <ion-label> Line Up </ion-label>
    </div>
    <table-grid v-if="(nationalId === 8 || nationalId === 12)" :title="'Players'" :headers="kosovoGrid.headers" :rows="kosovoGrid.rows"/>
    <ion-list v-if="selectedTeamId === match.homeTeam._id && homeLineups.length && hasAssignedPlayer('home') && ![8, 12].includes(nationalId)" lines="none">
      <ion-item
        class="player-line-item"
        v-for="{
          position: { abbreviation, number },
          shirtNum,
          classification,
          firstName,
          lastName,
          isCaptain,
          _id,
          suspend,
        } in homeLineups"
        :key="number"
        @click="_id ? $router.push(`/players/${_id}`) : null"
      >
        <ion-fab-button size="small" color="dark" class="position-circle">
          {{ shirtNum || number }}
        </ion-fab-button>
        <ion-label
          :class="{ 'light-text': !firstName, 'player-label': true }"
          >
          {{ firstName ? `${firstName} ${lastName} ` : "Unassigned" }}
          <ion-badge class="ml-10" color="light" v-if="isCaptain">C</ion-badge>
        </ion-label>
        <ion-card class="card-sspd" v-if="get(suspend, 'isSuspendedFromMatch', false)">
          SSPD
        </ion-card>
        <ion-badge slot="end" color="danger">
          {{nationalId === 2? classification :  abbreviation }}
        </ion-badge>
      </ion-item>
    </ion-list>
    <ion-list v-else-if="selectedTeamId === match.awayTeam._id && awayLineups.length && hasAssignedPlayer('away') && ![8, 12].includes(nationalId)" lines="none">
      <!-- <ion-item-sliding -->
      <ion-item
        class="player-line-item"
        v-for="{
          position: { abbreviation, number },
          firstName,
          lastName,
          classification,
          shirtNum,
          isCaptain,
          _id,
          suspend,
        } in awayLineups"
        :key="number"
        @click="_id ? $router.push(`/players/${_id}`) : null"
      >
        <ion-fab-button
          size="small"
          color="dark"
          class="position-circle"
        >
          {{ shirtNum || number }}
        </ion-fab-button>
        <ion-label
          :class="{ 'light-text': !firstName, 'player-label': true }"
          >
          {{ firstName ? `${firstName} ${lastName} ` : "Unassigned" }}
          <ion-badge class="ml-10" color="light" v-if="isCaptain">C</ion-badge>
        </ion-label>
        <ion-card class="card-sspd" v-if="get(suspend, 'isSuspendedFromMatch', false)">
          SSPD
        </ion-card>
        <ion-badge slot="end" color="danger">
          {{nationalId === 2? classification :  abbreviation }}
        </ion-badge>
      </ion-item>
    </ion-list>

  </ion-grid>
  <ion-grid v-if="hasTeamList && enableSubs">
    <ion-list-header class="mt-10" v-if="showSubHeader"> Substitute Players </ion-list-header>
    <ion-list v-if="selectedTeamId === match.homeTeam._id && homeSubs.length && hasAssignedSub('home')" lines="none">
      <!-- <ion-item-sliding -->
      <ion-item
        class="player-line-item"
        v-for="{
          position: { abbreviation, number },
          firstName,
          lastName,
          shirtNum,
          classification,
          isCaptain,
          _id,
        } in homeSubs"
        :key="number"
        @click="_id ? $router.push(`/players/${_id}`) : null"
      >
        <ion-fab-button
          size="small"
          color="dark"
          class="position-circle"
        >
          {{ shirtNum || number }}
        </ion-fab-button>
        <ion-label
          :class="{ 'light-text': !firstName, 'player-label': true }"
          >
          {{ firstName ? `${firstName} ${lastName}` : "Unassigned" }}
          <ion-badge class="ml-10" color="light" v-if="isCaptain">C</ion-badge>
        </ion-label>
        <ion-badge slot="end" color="danger">
          {{nationalId === 2? classification :  abbreviation }}
        </ion-badge>
      </ion-item>
    </ion-list>
    <ion-list v-else-if="selectedTeamId === match.awayTeam._id && awaySubs.length && hasAssignedSub('away')" lines="none">
      <ion-item
        class="player-line-item"
        v-for="{
          position: { abbreviation, number },
          firstName,
          lastName,
          shirtNum,
          classification,
          isCaptain,
          _id,
        } in awaySubs"
        :key="number"
        @click="_id ? $router.push(`/players/${_id}`) : null"
      >
        <ion-fab-button
          size="small"
          color="dark"
          class="position-circle"
        >
          {{ shirtNum || number }}
        </ion-fab-button>
        <ion-label
          :class="{ 'light-text': !firstName, 'player-label': true }"
          >
          {{ firstName ? `${firstName} ${lastName}` : "Unassigned" }}
          <ion-badge class="ml-10" color="light" v-if="isCaptain">C</ion-badge>
        </ion-label>
        <ion-badge slot="end" color="danger">
          {{nationalId === 2? classification :  abbreviation }}
        </ion-badge>
      </ion-item>
    </ion-list>
  </ion-grid>
  <ion-grid v-if="hasTeamList" class="mb-2">
    <ion-list-header class="mt-10" v-if="showNPHeader"> Staff </ion-list-header>
    <ion-list v-if="selectedTeamId === match.homeTeam._id && hasAssignedNP('home')" lines="none">
      <ion-item
        class="player-line-item"
        v-for="{ _id, firstName, lastName, memberType } in homeNPData"
        :key="_id"
        @click="_id ? $router.push(`/players/${_id}`) : null"
      >
        <ion-fab-button
          size="small"
          color="dark"
          class="position-circle"
        >
          {{ capitalize(first(memberType)) }}
        </ion-fab-button>
        <ion-label
          :class="{ 'light-text': !firstName, 'player-label': true  }"
          >{{ firstName ? `${firstName} ${lastName}` : "Unassigned" }}
        </ion-label>
        <ion-badge slot="end" color="danger">
          {{ capitalize(memberType) }}
        </ion-badge>
      </ion-item>
      <!-- <ion-item class="player-line-item">
        <ion-fab-button
          size="small"
          color="dark"
          class="position-circle"
        >
        </ion-fab-button>
        <ion-label
          :class="{ 'light-text': !firstName, 'player-label': true }"
          >Unassigned
        </ion-label>
        <ion-badge slot="end" color="danger">
          {{ abbreviation }}
        </ion-badge>
      </ion-item> -->
    </ion-list>
    <ion-list v-else-if="selectedTeamId === match.awayTeam._id && hasAssignedNP('away')" lines="none">
      <ion-item
        class="player-line-item"
        v-for="{ _id, firstName, lastName, memberType } in awayNPData"
        :key="_id"
        @click="_id ? $router.push(`/players/${_id}`) : null"
      >
        <ion-fab-button size="small" color="dark" class="position-circle">
          {{ capitalize(first(memberType)) }}
        </ion-fab-button>
        <ion-label
          :class="{ 'light-text': !firstName, 'player-label': true  }"
          >{{ firstName ? `${firstName} ${lastName}` : "Unassigned" }}
        </ion-label>
        <ion-badge slot="end" color="danger">
          {{ capitalize(memberType) }}
        </ion-badge>
      </ion-item>
      <!-- <ion-item class="player-line-item">
        <ion-fab-button size="small" color="dark" class="position-circle">
        </ion-fab-button>
        <ion-label
          :class="{ 'light-text': !firstName, 'player-label': true }"
          >Unassigned
        </ion-label>
        <ion-badge slot="end" color="danger">
          {{ abbreviation }}
        </ion-badge>
      </ion-item> -->
    </ion-list>
  </ion-grid>
  <ion-grid class="no-event-container" v-if="noTeamList">
    <ion-text color="secondary">
      <h1 class="teamlist-header">No Lineup Selected</h1>
    </ion-text>
  </ion-grid>
  <ion-modal :is-open="pitchModal" @onDidDismiss="pitchModal=false" css-class="custom-modal-fieldview" :key="pitchModalKey">
    <pitch
      :key="key"
      :isHomeTeam ="isHomeModal"
      :positions="isHomeModal? homeData: awayData"
      :teamList="isHomeModal? homeTeamList: awayTeamList"
      :match="match"
      :teamId="isHomeModal? match.homeTeam._id: match.awayTeam._id"
      :close="() => pitchModal = false"
      @openHomeSquad="openHomeSquad"
      @updatePositions="(positions) => updatePositions(positions, 'homePositions')"
    ></pitch>
  </ion-modal>

</template>

<script>
import {
  loadingController
} from "@ionic/vue";
import { isEmpty } from 'lodash';
import { addCircleOutline, addOutline, shirt } from "ionicons/icons";
import Pitch from "./pitch.vue";
import { onMounted, toRef, ref, getCurrentInstance, computed } from "vue";
import { mapGetters } from 'vuex';
import { fetchTeamListData } from "@/actions/match";
import _ from 'lodash';
import TableGrid from '@/components/TableGrid.vue';

export default {
  name: "Teamlist",
  props: ["match"],
  components: {
    Pitch,
    TableGrid
  },
  setup(props) {
    const app = getCurrentInstance();
    const { $store } = app.appContext.config.globalProperties
    const match = toRef(props, "match");
    const modal = ref(undefined);
    const pitchModal = ref(undefined);
    const isHomeModal = ref(false);
    const nationalId = +process.env.VUE_APP_NATIONAL_ID;
    const selected = ref(undefined);
    const squadVisible = ref(false);
    const homeTeamList = ref(undefined);
    const awayTeamList = ref(undefined);
    const positions = ref([]);
    const homeData = ref([]);
    const awayData = ref([]);
    const homeNPData = ref([]);
    const awayNPData = ref([]);
    const selectedTeamId = computed(() => $store.getters["match/selectedTeamId"]);
    const activeTeams = computed(() => $store.getters["user/activeTeamIds"]);

    onMounted(async () => {
      const loading = await loadingController.create({
        message: "Fetching teamlist data..."
      });
      loading.present();
      const teamListData = await fetchTeamListData(match.value);
      console.log({
        teamListData
      });
      loading.dismiss();
      homeTeamList.value = teamListData.homeTeamList;
      awayTeamList.value = teamListData.awayTeamList;
      homeData.value = teamListData.homeData;
      awayData.value = teamListData.awayData;
      homeNPData.value = teamListData.homeNPData;
      awayNPData.value = teamListData.awayNPData;
    });

    return {
      nationalId,
      capitalize: _.capitalize,
      first: _.first,
      addCircleOutline,
      addOutline,
      shirt,
      modal,
      pitchModal,
      isHomeModal,
      homeTeamList,
      awayTeamList,
      selected,
      squadVisible,
      positions,
      homeData,
      awayData,
      homeNPData,
      awayNPData,
      selectedTeamId,
      activeTeams,
      isEmpty
    };
  },
  data() {
    return {
      tableGridTitle: 'Players',
      tableGridHeaders: [],
      tableGridRows: [],
      get: _.get,
    }
  },
  computed: {
    ...mapGetters('national', ['scoringEvents', 'playerMovements']),
    kosovoGrid() {
      const rows = [];
      const filteredEvents = this.filteredEvents;
      this.homeLineups.forEach((item, i) => {
        item.arrangeBy = parseInt(item.shirtNum || item.number);
      });
      const lineups = +this.selectedTeamId == +this.match.homeTeam._id ? _.orderBy(this.homeLineups, ['arrangeBy', 'asc']) : _.orderBy(this.awayLineups, ['arrangeBy', 'asc']);
      const headers = _.map(filteredEvents, fE => this.abbreviate(fE));
      lineups.forEach((item, i) => {
        const number = item.shirtNum || item.number;
        const name = item.firstName ? `${item.firstName} ${item.lastName} ` : "Unassigned";
        const stats = this.generateStat(item._id);
        const statsTotal = _.map(stats, s => s.total);
        const row = [number, name, ...statsTotal];
        rows.push(row);
      });
      return {
        headers: ['', 'Player Name', ...headers],
        rows
      };
    },
    filteredEvents() {
      return this.scoringEvents.concat(this.playerMovements).filter(e => e.visibleInLadders || e.visibleInLadders === undefined);
    },
    enableFieldView() {
      return this.nationalId !== 4;
    },
    enableSubs() {
      return this.nationalId !== 8;
    },
    homeLineups() {
      return _.filter(this.homeData, d => d.position.type === "line-up").filter(p => p.firstName || p.lastName);
    },
    homeSubs() {
      return _.filter(this.homeData, d => d.position.type === "substitute").filter(p => p.firstName || p.lastName);
    },
    awayLineups() {
      return _.filter(this.awayData, d => d.position.type === "line-up").filter(p => p.firstName || p.lastName);
    },
    awaySubs() {
      return _.filter(this.awayData, d => d.position.type === "substitute").filter(p => p.firstName || p.lastName);
    },
    playingMemberTypes() {
      return _.map(this.$store.getters["national/playingMemberTypes"], "type");
    },
    nonplayingMemberTypes() {
      return _.map(
        this.$store.getters["national/nonplayingMemberTypes"],
        "type"
      );
    },
    homeSquadPlayers() {
      const recentIds = _.uniq(_.map(this.homeData, "_id"));
      return _.filter(
        this.homeSquad,
        s =>
          _.includes(this.playingMemberTypes, s.memberType) &&
            !_.includes(recentIds, s._id)
      );
    },
    homeSquadNonPlayers() {
      const recentIds = _.uniq(_.map(this.homeNPData, "_id"));
      return _.filter(
        this.homeSquad,
        s =>
          _.includes(this.nonplayingMemberTypes, s.memberType) &&
            !_.includes(recentIds, s._id)
      );
    },
    awaySquadPlayers() {
      const recentIds = _.uniq(_.map(this.awayData, "_id"));
      return _.filter(
        this.awaySquad,
        s =>
          _.includes(this.playingMemberTypes, s.memberType) &&
            !_.includes(recentIds, s._id)
      );
    },
    awaySquadNonPlayers() {
      const recentIds = _.uniq(_.map(this.awayNPData, "_id"));
      return _.filter(
        this.awaySquad,
        s =>
          _.includes(this.nonplayingMemberTypes, s.memberType) &&
            !_.includes(recentIds, s._id)
      );
    },
    hasTeamList() {
      if (!this.match || !(this.match.homeTeam || this.match.awayTeam)) return false;
      if(this.selectedTeamId === this.match.homeTeam._id) {
        return [this.homeSubs, this.homeLineups, this.homeNPData].some(l => l.length > 0)
      }
      return [this.awaySubs, this.awayLineups, this.awayNPData].some(l => l.length > 0)
    },
    showLineUpHeader() {
      return (this.selectedTeamId === this.match.homeTeam._id && this.homeLineups.length && this.hasAssignedPlayer('home')) ||
        (this.selectedTeamId === this.match.awayTeam._id && this.awayLineups.length && this.hasAssignedPlayer('away'))
    },
    showSubHeader() {
      return (this.selectedTeamId === this.match.homeTeam._id && this.homeSubs.length && this.hasAssignedPlayer('home')) ||
        (this.selectedTeamId === this.match.awayTeam._id && this.awaySubs.length && this.hasAssignedPlayer('away'))
    },
    showNonPlayerHeader() {
      return (this.selectedTeamId === this.match.homeTeam._id && this.homeNPData.length && this.hasAssignedPlayer('home')) ||
        (this.selectedTeamId === this.match.awayTeam._id && this.awayNPData.length && this.hasAssignedPlayer('away'))
    },
    noTeamList() {
      return !this.hasTeamList
      || (!this.showLineUpHeader && !this.showSubHeader && !this.showNonPlayerHeader)
    }
  },
  methods: {
    abbreviate(stat) {
      if (stat.abbreviation) return stat.abbreviation;
      return stat.name.split(' ').map(s => s.charAt(0)).join('');
    },
    generateStat(playerId) {
      const { scoringEvents, playerMovements } = this;
      const isHome = +this.selectedTeamId == +this.match.homeTeam._id;
      const matchWithPlayerScoring = _.filter(this.match.scoringEvents, sE => +playerId == +_.get(sE, 'meta.player._id'))
      const matchWithPlayerMovements = _.filter(this.match.playerMovements, pM => +playerId == +_.get(pM, 'meta.on._id'))
      const scorings = scoringEvents
        .filter(e => e.visibleInLadders || e.visibleInLadders === undefined)
        .reduce((acc, event) => {
          const { type, name: eventName } = event;
          const total = _.filter(_.filter(this.match.scoringEvents, sE => sE.type == type), e => e.type === type && e.meta && e.meta.player && e.isHomeTeam == isHome && e.meta.player._id === playerId).length
          return acc.concat({ type, total, eventName });
        }, [])
      const movements = playerMovements
        .filter(e => e.visibleInLadders || e.visibleInLadders === undefined)
        .reduce((acc, event) => {
          const { type, name: eventName } = event;
          const total = _.filter(_.filter(this.match.playerMovements, pM => pM.type == type), e => e.type === type && e.meta && e.isHomeTeam == isHome && (e.meta.off && e.meta.off._id === playerId || e.meta.on && e.meta.on._id === playerId)).length
          return acc.concat({ type, total, eventName });
        }, [])
      return scorings.concat(movements);
    },
    openPitchModal(type) {
      if(type === "home") {
        this.isHomeModal = true;
        this.pitchModal = true;
      } else {
        this.isHomeModal = false;
        this.pitchModal = true;
      }
    },
    hasAssignedPlayer(type) {
      const home = type === "home";
      const lineups = home ? this.homeLineups : this.awayLineups;
      return lineups && lineups.some(position => position.firstName || position.lastName);
    },
    hasAssignedNP(type) {
      const home = type === "home";
      const npData = home ? this.homeNPData : this.awayNPData;
      return npData && npData.some(position => position.firstName || position.lastName);
    },
    hasAssignedSub(type) {
      const home = type === "home";
      const subs = home ? this.homeSubs : this.awaySubs;
      return subs && subs.some(position => position.firstName || position.lastName);
    },
  },
};
</script>

<style scoped>

.team-segment {
  padding: 10px 15px;
}

.player {
  display: flex;
  align-items: center;
}

.player-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  font-family: 'bold';
}
  ion-label {
    font-family: "BrownStd-Regular";
    font-style: normal;
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 137.4%;
    letter-spacing: 0.02em;
    color: white;
  }

.player .number {
  font-family: var(--font-light);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  width: 25px;
  font-size: 11px;
  font-weight: 200;
  border: 1.5px solid rgba(129, 129, 129, 0.7);
  border-radius: 100%;
  background-color: rgba(240, 240, 240, 0.3);
}

.player .name {
  font-size: 13px;
}

.player .position {
  opacity: 0.5;
  font-family: var(--font-light);
}

.squad {
  width: 40px;
  height: 40px;
  border: 1px solid rgba(218, 31, 31, 0.5);
  border-radius: 100%;
  background-color: rgba(255, 255, 255, 0.5);
}
.squad svg {
  width: 30px;
  height: 30px;
  color: rgba(233, 39, 39, 0.7);
}

.divider {
  height: 0.5px;
  width: 90%;
  background-color: rgb(175, 175, 175, 0.25);
  margin: 5px 0;
}
.divider .label {
  position: absolute;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  padding: 10px;
  font-family: var(--font-light);
  font-size: 14px;
  line-height: 14px;
  color: rgb(175, 175, 175);
  background-color: var(--ion-background-color);
}

.team-select-label {
  margin-bottom: 1rem;
  font-family: "BrownStd-Regular";
  font-style: normal;
  font-weight: bold;
  font-size: 1.3rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: #2d3a45;
}

ion-list-header {
  align-items: flex-start;
  font-family: "BrownStd-Regular";
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;

  letter-spacing: 0.02em;

  color: white;
}

.light-text {
  color: white !important;
  /* color: rgba(0, 0, 0, 0.4); */
}

.position-circle {
  --box-shadow: none;
  width: 2rem;
  height: 2rem;
  margin-left: 0;
  margin-right: 0.65rem;
}

.player-label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 1rem;
}

ion-list {
  border-radius: 1rem;
  background: transparent;
  box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
}

ion-item {
  --color: white;
  --background: transparent;
}

.no-event-container {
  height: 48vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.teamlist-header {
  align-items: flex-start;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;
  /* margin-bottom: 1rem; */
  padding-left: 0;

  letter-spacing: 0.02em;

  color: white;
}

</style>

<style>
.custom-modal {
  --height: 80% !important;
  align-items: flex-end;
}
.custom-modal .modal-wrapper {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.custom-modal-fieldview {
   --height: 70% ;
    --width: 50% ;
  align-items: flex-end;
}
@media only screen and (min-width: 280px) {
.custom-modal-fieldview {
  --height: 70% ;
  --width: 100% ;
  align-items: flex-end;
  }
}
@media only screen and (min-width: 360px) {
.custom-modal-fieldview {
  --height: 75% ;
  --width:90%;
  align-items: center;
  }
}
@media only screen and (min-width: 375px) {
  .custom-modal-fieldview {
    --height: 86% ;
    --width:90%;
    align-items: center;
    }
  }

@media only screen and (min-width: 390px) {
  .custom-modal-fieldview {
    --height: 70% ;
    --width:90%;
    align-items: center;
    }
  }
@media only screen and (min-width: 540px) {
  .custom-modal-fieldview {
    --height: 84% ;
    --width:65%;
    align-items: center;
    }
  }
@media only screen and (min-width: 768px) {
  .custom-modal-fieldview {

    --height: 81% ;
    --width: 60% ;
      align-items: center;
    }
  }
@media only screen and (min-width: 820px) {
  .custom-modal-fieldview {

    --height: 68% ;
    --width: 60% ;
      align-items: center;
    }
  }
@media only screen and (min-width: 912px) {
  .custom-modal-fieldview {

    --height: 60% ;
    --width: 60% ;
      align-items: center;
    }
  }
@media only screen and (min-width: 1024px){
  .custom-modal-fieldview {
    --height: 83% ;
    --width: 35% ;
      align-items: center;
    }
  }

@media only screen and (min-width: 1280px) {
  .custom-modal-fieldview {
    --height: 83% ;
    --width: 47% ;
      align-items: center;
    }
  }
@media only screen and (min-width: 1281px) and (min-height: 900px) {
  .custom-modal-fieldview {
    --height: 83% ;
    --width: 57% ;
      align-items: center;
    }
  }

.custom-modal-fieldview .modal-wrapper {


  border-radius: 25px;
  /* add box shadow */
  /* box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5); */
  box-shadow: none;
  background:transparent;
  box-shadow:none;

}
ion-page {
  --background: transparent;
}

.card-sspd {
  background-color: red;
  color: white;
  font-size: 0.8rem;
  min-width: 3rem;
  min-height: 1.2rem;
  border-radius: 25%/50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
